(function ($) {
	"use strict";
	$(function () {
		var isButtonClick = false;

		$(".js-newsletter-form").each(function () {
			$(this).validate({
				onkeyup: false,
				errorPlacement: function (error, element) {
					$('#modal-alert').iziModal('open');
				},
				rules: {
					email: {
						required: true,
						email: true
					},
					aszf: {
						required: true
					}
				}
			});
		});

		$('.js-newsletter-form').submit(function (e) {
			e.preventDefault();
			var $this = $(this);

			if ($this.valid()) {
				if (isButtonClick) {
					return false;
				}

				isButtonClick = true;

				$.ajax({
					type: "post",
					context: this,
					dataType: "json",
					url: localize.ajaxurl,
					data: {
						action: "mailchimpsubscribe",
						datas: $this.serializeArray(),
					},
					success: function (response) {
						isButtonClick = false;

						if (!response['fault']) {
							$this.trigger('reset');
							$('#modal-success').iziModal('open');
						} else {
							if (response['mailchimp_error']) {
								alert(response['msg']);
							} else {
								$('#modal-alert').iziModal('open');
							}
						}
					}
				});

				return false;
			}
		});

	});
})(jQuery);
